import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToConsumerSeek = (
    consumerSeek$: Observable<number>,
    playbackStore: IPlaybackStore
): Subscription =>
    consumerSeek$
        .subscribe((time: number) => playbackStore.actions.updateCurrentTime(time));

export default subscribeToConsumerSeek;